import Vue from 'vue'

// axios
import axios from 'axios'
import Qs from 'qs'

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'comma' }),
})

Vue.prototype.$http = axiosIns

// ========= API URL logger =========
const apiLogs = []
const apiSet = new Set()

axiosIns.interceptors.request.use(
  config => {
    const method = (config.method || 'get').toUpperCase()
    if (method === 'GET') {
      const key = config.url
      if (!apiSet.has(key)) {
        apiSet.add(key)
        apiLogs.push(key)
      }
      //      console.log(apiLogs)
    }
    return config
  },
  error => Promise.reject(error),
)
window.printApiLogs = () => console.log(apiLogs)
export default axiosIns
